if (!customElements.get('cart-drawer-recommendations')) {
  // Document level event delegation for recommendations add to cart
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('cart-drawer-recommendations .js-add-to-cart, cart-drawer-new-launches .js-add-to-cart');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    e.preventDefault();
    // console.log('[CartRecommendations] Global click intercepted for variant:', btn.dataset.variantId);
    btn.classList.add('is-loading');
    const originalText = btn.textContent;
    btn.textContent = '...';

    try {
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionsToUpdate = new Set(['cart-icon-bubble']);
      cartItemsComponents.forEach(item => {
        if (item.dataset.sectionId) sectionsToUpdate.add(item.dataset.sectionId);
      });

      const cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url)
        || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'cart/add.js')
        || '/cart/add.js';

      // console.log('[CartRecommendations] Adding variant via:', cartAddUrl);
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ 
          id: btn.dataset.variantId, 
          quantity: 1, 
          sections: Array.from(sectionsToUpdate).join(',')
        })
      });

      if (!response.ok) throw new Error('Cart add failed');
      const data = await response.json();
      // console.log('[CartRecommendations] Add to cart response:', data);

      // Fetch the updated cart to get the correct item_count
      let cartData = {};
      try {
        const cartRes = await fetch('/cart.js');
        cartData = await cartRes.json();
        // console.log('[CartRecommendations] Updated cart data:', cartData);
      } catch (e) {
        console.error('[CartRecommendations] Failed to fetch updated cart details:', e);
      }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartData,
          sourceId: 'cart-drawer-recommendations',
          data: {
            sections: data.sections
          }
        }
      }));
      // console.log('[CartRecommendations] cart:update event dispatched');
    } catch (err) {
      console.error('[CartRecommendations] Error in click handler:', err);
    } finally {
      btn.classList.remove('is-loading');
      btn.textContent = originalText;
    }
  });

  customElements.define('cart-drawer-recommendations', class extends HTMLElement {
    connectedCallback() {
      // console.log('[CartRecommendations] connectedCallback triggered for url:', this.dataset.url);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          // console.log('[CartRecommendations] Fetch response received');
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('cart-drawer-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            // console.log('[CartRecommendations] Found recommendations HTML, updating innerHTML');
            this.innerHTML = recommendations.innerHTML;
          } else {
            console.log('[CartRecommendations] No recommendations found in fetched HTML');
          }
        })
        .catch(e => console.error('[CartRecommendations] Fetch error:', e));
    }
  });

  if (!customElements.get('cart-drawer-new-launches')) {
    customElements.define('cart-drawer-new-launches', class extends HTMLElement {});
  }
}
